
import { defineComponent } from 'vue'
import GalleryMini from '@/components/GalleryMini.vue'
import Hero from '@/components/HeroMain.vue'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: 'Home',
  components: { GalleryMini, Hero },
  setup () {
    const { t, d } = useI18n()
    return { t, d }
  },
  data: () => {
    return {
      // Only the hours and minutes are used, the rest is entered just because the constructor needs it.
      maxDeliveryTime: new Date(2020, 0, 1, 21, 0)
    }
  }
})
